module.exports = __webpack_public_path__ + "img/jerusalem-header.37296a15.svg";